import 'dayjs/locale/cs';

import type { Dayjs, OptionType } from 'dayjs';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { isValueEmpty } from '@/utils/value';

dayjs.extend(timezone);
dayjs.locale('cs');
dayjs.extend(utc);

export type DayjsProps = Dayjs | Date | string | number | undefined;

export const dayjsCs = (date?: DayjsProps, inputFormat?: OptionType): Dayjs => {
  try {
    return dayjs(date, inputFormat).tz('Europe/Prague');
  } catch {
    return dayjs('Invalid Date');
  }
};

export const isDateInRange = (start?: DayjsProps | null, end?: DayjsProps | null, date?: DayjsProps) => {
  if (isValueEmpty(start) || isValueEmpty(end)) {
    return false;
  }

  const startDate = dayjsCs(start);
  const endDate = dayjsCs(end);
  const currentDate = dayjsCs(date);

  return currentDate.isAfter(startDate) && currentDate.isBefore(endDate);
};
